<script setup lang="ts">
import { computed, ref } from 'vue'
import { exportReportAction } from '@/api/functions/growth/growth-chart.actions'
import { useMutationApi } from '@/composables/useApi'
import { useToast } from '@/composables/useToast'
import { getErrorMessage } from '@/utils/errorUtils'
import GrowthChart from './partials/GrowthChart.vue'

const toast = useToast()

const transactionsReport = ref('transactions')
const minDate = ref('')
const maxDate = ref('')

const reportOptions = computed(() => [
  { label: 'گزارش تراکنش‌ها', value: 'transactions' },
  { label: 'گزارش کاربران', value: 'users' },
  { label: 'گزارش درخواست‌ها', value: 'requisitions' },
  { label: 'گزارش تراکنش اولی‌ها', value: 'firstTimeTransactionUsers' },
  { label: 'گزارش LRFM', value: 'lrfm' },
  { label: 'گزارش مالی', value: 'financial' },
])

const downloadReportMutation = useMutationApi({
  mutationFn: () => {
    if (!transactionsReport.value || !minDate.value || !maxDate.value) {
      throw new Error('لطفاً نوع گزارش و تاریخ‌ها را انتخاب کنید')
    }
    if (new Date(maxDate.value) < new Date(minDate.value)) {
      throw new Error('تاریخ «تا» نمی‌تواند قبل از تاریخ «از» باشد')
    }
    return exportReportAction(transactionsReport.value, minDate.value, maxDate.value)
  },
  onSuccess: (resp) => {
    if (resp.data?.status === 1 && resp.data?.url) {
      const link = document.createElement('a')
      link.href = resp.data.url
      link.download = resp.data.url.split('/').pop() || 'report.xlsx'
      link.target = '_blank'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    } else if (resp.data?.status === 0) {
      alert(resp.data?.message || 'فایل در حال پردازش است و به ایمیل شما ارسال خواهد شد.')
    } else {
      toast.error('خطا')
      // alert(resp.data?.message || resp.meta?.message || 'خطا در دریافت گزارش.');
    }
  },
  onError: (error: Error) => {
    toast.error(getErrorMessage(error), 'خطا')
    // alert(error?.message || 'خطا در ارتباط با سرور.');
  },
})
</script>

<template>
    <div class="flex flex-col mb-32">
        <div class="flex flex-col lg:flex-row lg:items-center justify-between mb-14 lg:mb-10">
            <span class="text-[#1b325a] text-[22px]">رشد</span>
            <div
                class="w-full lg:w-auto grow flex flex-col lg:flex-row gap-4 lg:gap-3.5 items-center lg:justify-end lg:h-12!">
                <Select variant="checkbox" v-model="transactionsReport" class="lg:w-[220px]! h-12!"
                    placeholder="گزارش تراکنش‌ها" :options="reportOptions" />
                <AlirezaDatePicker v-model="minDate" placeholder="از" class="lg:w-[120px]! h-12!" />
                <AlirezaDatePicker v-model="maxDate" placeholder="تا" class="lg:w-[120px]! h-12!" />
                <Button @click="downloadReportMutation.mutate()" :isAdmin="true"
                    class="w-full lg:w-auto px-[21.3px]! rounded-xl h-12! border-2 py-0 text-base font-medium">
                    <span class="flex items-center justify-center gap-2 ">
                        <img width="19" src="/svg/print-svgrepo-white.svg" />
                        چاپ گزارش
                    </span>
                </Button>
            </div>
        </div>

        <GrowthChart />
    </div>
</template>
